import { render, staticRenderFns } from "./ed-deck-library-creator.vue?vue&type=template&id=539e4f1b&scoped=true&"
import script from "./ed-deck-library-creator.ts?vue&type=script&lang=ts&"
export * from "./ed-deck-library-creator.ts?vue&type=script&lang=ts&"
import style0 from "./ed-deck-library-creator.scss?vue&type=style&index=0&id=539e4f1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539e4f1b",
  null
  
)

export default component.exports